
<div>
    <table class="table table-striped text-xxs">
        <thead class="btn-primary text-white">
        <tr>
            <th scope="col">#</th>
            <th v-for="(col, index) in columns" :key="index" scope="col">{{ col.label }}</th>
            <th v-if="$slots.actions" scope="col">Action</th>
        </tr>
        </thead>
        <tbody class="text-black">
        <tr v-for="(item, index) in data" :key="item.id">
            <th scope="row">{{ index + 1 }}</th>
            <td v-for="(col, i) in columns" :key="i">{{ item[col.key] }}</td>

            <td v-if="$slots.actions">
            <slot name="actions" :item="item" :index="index"></slot>
            </td>
        </tr>
        </tbody>
    </table>
</div>

  

  